// extracted by mini-css-extract-plugin
export default {"top-page":"style_top-page__arlST"};